import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, Package, Tags, Users, TrendingUp,
  Boxes, FileBarChart, LogOut, Menu, X, Bell, Search
} from 'lucide-react';
import AdminBottomNav from './AdminBottomNav';
import './Admin.css';

const navItems = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/admin/products', label: 'Products', icon: Package },
  { to: '/admin/categories', label: 'Category', icon: Tags },
  { to: '/admin/customers', label: 'Customers', icon: Users },
  { to: '/admin/sales', label: 'Sales', icon: TrendingUp },
  { to: '/admin/inventory', label: 'Inventory', icon: Boxes },
  { to: '/admin/reports', label: 'Reports', icon: FileBarChart },
];

function AdminLayout({ children, setIsAdmin }) {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    setIsAdmin(false);
    navigate('/admin');
  };

  return (
    <div className="admin-shell">
      {/* Sidebar */}
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="admin-sidebar-logo">
          <span className="admin-logo-icon">☪</span>
          <div>
            <div className="admin-logo-main">BAYT AL-KHAYR</div>
            <div className="admin-logo-sub">ADMIN PANEL</div>
          </div>
        </div>

        <nav className="admin-nav">
          {navItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <item.icon size={18} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <button className="admin-logout-btn" onClick={handleLogout}>
          <LogOut size={18} /> Logout
        </button>
      </aside>

      {sidebarOpen && <div className="admin-sidebar-overlay" onClick={() => setSidebarOpen(false)}></div>}

      {/* Main Content */}
      <div className="admin-main">
        <header className="admin-topbar">
          <button className="admin-mobile-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
            {sidebarOpen ? <X size={22} /> : <Menu size={22} />}
          </button>

          <div className="admin-search-box">
            <Search size={16} />
            <input type="text" placeholder="Search products, orders, customers..." />
          </div>

          <div className="admin-topbar-actions">
            <button className="admin-icon-btn">
              <Bell size={18} />
              <span className="admin-notif-dot"></span>
            </button>
            <div className="admin-user-chip">
              <div className="admin-user-avatar">A</div>
              <div className="admin-user-info">
                <span className="admin-user-name">Admin User</span>
                <span className="admin-user-role">Super Admin</span>
              </div>
            </div>
          </div>
        </header>

        <main className="admin-content">
          {children}
        </main>
      </div>

      <AdminBottomNav setIsAdmin={setIsAdmin} />
    </div>
  );
}

export default AdminLayout;
